<template>
  <div>
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    />
    <div class="tableWrap">
      <Table
        border
        :columns="columns"
        size="small"
        stripe
        :data="dataSource"
        disabled-hover
        row-key="id"
        ref="tableRef"
      ></Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right">
          <Page
            show-total
            show-sizer
            :total="totalCount"
            :current="filter.pageIndex"
            :page-size="filter.pageSize"
            :page-size-opts="[10, 25, 50, 100]"
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import listMixins from '@/mixins/listMixins';
import { formItems, getColumns } from './config';
import authType from '@/config/authType';
import { instApplyDetailApi } from '@/api/approvalTask';
export default {
  name: 'dataManage',
  mixins: [listMixins],
  data() {
    return {
      authType,
      formItems,
      filter: {
        pageIndex: 1,
        pageSize: 10,
        auditType: 1,
        instStatus: ''
      },
      columns: getColumns({
        goAudit: this.goAudit
      }),
      tempGroupModalVisible: false,
      isEdit: false,
      currentRowId: ''
    };
  },
  computed: {
    ...mapState('approvalTask', ['totalCount', 'dataSource'])
  },
  methods: {
    ...mapActions('approvalTask', ['getTableInfo', 'submitStatus']),
    goAudit(id) {
      const { fullscreen, auditType } = this.$route.query;
      const path = fullscreen ? '/approvalDetailMaximize' : '/approvalDetail';
      const query = { instApplyId: id };
      if (fullscreen) {
        query.fullscreen = true;
      }
      this.$router.push({ path, query });
      // instApplyDetailApi(id).then(res => {
      //   const { data, code } = res.data;
      //   if (code == 200) {
      //     const trendsForm = { formData: data.formCurrData, renderJson: data.formDesignDef };
      //     localStorage.setItem('trendsForm', JSON.stringify(trendsForm));
      //     this.$router.push({ path: '/approvalDetail', query: { instApplyId: id } });
      //   }
      // });
    },
    handlerSubmit() {
      this.$refs.tempGroupModal.submit().then(res => {
        if (res) {
          this.tempGroupModalVisible = false;
        }
      });
    }
  },
  created() {
    const { auditType } = this.$route.query;
    if (auditType) this.filter.auditType = auditType;
  }
};
</script>
<style lang="less"></style>
